import React from 'react';
import queryString from 'query-string';
import block from 'propmods';

import { confirmEmail } from '../../api';
import { Loading } from '../Loading/Loading';
import { EmailConfirmationStage } from '../../types';
import { routes } from '../../lib/routes';
import Link from '../Link/Link';

import './EmailConfirmationPage.scss';

interface EmailConfirmationPageState {
    stage: EmailConfirmationStage;
    skillId: string;
}

const b = block('EmailConfirmationPage');

class EmailConfirmationPage extends React.Component<object, EmailConfirmationPageState> {
    public state: EmailConfirmationPageState = {
        stage: 'pending',
        skillId: '',
    };

    public componentDidMount() {
        const parsed = queryString.parse(location.search);

        if (!parsed.token) {
            return this.setState({ stage: 'failure' });
        }

        confirmEmail(parsed.token)
            .then((response) => {
                this.setState(response);
            })
            .catch((err) => {
                console.error(err);
                this.setState({ stage: 'failure' });
            });
    }

    public render() {
        return (
            <div {...b()}>
                <div {...b('message')}>{this.message}</div>
            </div>
        );
    }

    private get message() {
        switch (this.state.stage) {
            case 'pending':
                return <Loading centered />;
            case 'not-modified':
                return (
                    <>
                        Для данного
                        <Link to={routes.app.skillPage(true, 'settings', this.state.skillId)}>{' навыка '}</Link>
                        адрес уже подтвержден
                    </>
                );
            case 'success':
                return (
                    <>
                        Email
                        <Link to={routes.app.skillPage(true, 'settings', this.state.skillId)}>{' навыка '}</Link>
                        успешно подтвержден
                    </>
                );
            case 'failure':
                return 'Произошла ошибка при подтверждении. Возможно, вы не авторизованы, или ссылка устарела.';
        }
    }
}

export default EmailConfirmationPage;
